import { useEffect, useRef } from 'react';

import { useMount } from '@/hooks/useMount';

export function useTimeout({ callback, timeout }) {
  const timeoutId = useRef();
  const mounted = useMount();

  function cleanUp() {
    if (timeoutId.current) {
      timeoutId.current = clearTimeout(timeoutId.current);
    }
  }

  useEffect(
    function effect() {
      return cleanUp;
    },
    []
  );

  useEffect(
    function effect() {
      cleanUp();

      function timeoutCallback() {
        if (!mounted.current) return;

        callback();
      }

      if (Number.isFinite(timeout) && timeout > 0) {
        timeoutId.current = setTimeout(timeoutCallback, timeout);
      }
    },
    [callback, timeout]
  );
}
